import { Puzzle } from "@/types/serializers"
import formatDate from "@/utils/formatDate"
import { Link } from "@inertiajs/react"

const PuzzleItem = (puzzle: Puzzle) => {
  const { id, title, created_at } = puzzle

  return (
    <Link href={`/puzzles/${id}`} className="padding block hover:bg-gray-100">
      <li className="flex justify-between gap-x-6 py-5">
        <p className="min-w-0 flex-auto truncate text-base leading-6 font-medium text-gray-900">
          {title ?? "Draft Puzzle"}
        </p>
        <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
          <p className="text-sm text-gray-600">
            {formatDate({
              date: new Date(created_at),
              format: "long",
            })}
          </p>
        </div>
      </li>
    </Link>
  )
}

export default PuzzleItem
